import React from "react";
import { cn } from "../../lib/utils/utils";

const variants = {
  default: "bg-primary text-white hover:bg-primary-hover shadow-lg shadow-primary/20",
  destructive: "bg-rose-600 text-white hover:bg-rose-700 shadow-lg shadow-rose-600/20",
  secondary: "bg-slate-900 text-white hover:bg-slate-800",
  outline: "border border-slate-200 bg-white/80 text-panel-ink hover:bg-white",
  ghost: "text-panel-muted hover:bg-slate-100 hover:text-panel-ink"
};

const sizes = {
  default: "h-11 px-4 py-2",
  sm: "h-9 px-3 text-sm",
  lg: "h-12 px-6 text-base"
};

export const Button = React.forwardRef(function Button(
  { className, variant = "default", size = "default", ...props },
  ref
) {
  return (
    <button
      ref={ref}
      className={cn(
        "inline-flex items-center justify-center rounded-2xl font-semibold transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40 disabled:pointer-events-none disabled:opacity-50",
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    />
  );
});
